import {
  LOAD_USER_CALCULS,
  CHANGE_CALCULS_SORT,
  CHANGE_CALCULS_PAGE,
  DELETE_CALCUL,
  DELETE_CALCUL_SUCCESS,
  DELETE_CALCUL_FAILED,
  DUPLICATE_CALCUL,
  LOAD_CALCUL,
  CLEAR_CALCUL,
  REMOVE_REPORTS,
  GET_ALL_USER_CALCULS,
  UPDATE_CALCULS_LIMIT,
  SET_CALCUL_ARCHIVED,
  RESTORE_ARCHIVED_CALCUL,
  CHANGE_CALCULS_SEARCH,
  UPDATE_CALCUL_ATTRIBUTES,
  MANAGE_CALCULS_BULK,
  UPDATE_CALCULS_FILTERS,
  CLOSE_CALCULS_FILTERS_SECTION,
  OPEN_CALCULS_FILTERS_SECTION,
} from "../constants";

import { SEND_XML_TO_EDEC } from "../../fdes/constants";

export function loadUserCalculs() {
  return {
    type: LOAD_USER_CALCULS,
  };
}
export function getCalcul(calculId) {
  return {
    type: LOAD_CALCUL,
    calculId,
  };
}
export function changeCalculsSort(sort) {
  return {
    type: CHANGE_CALCULS_SORT,
    sort,
  };
}
export function changeCalculsPage(page) {
  return {
    type: CHANGE_CALCULS_PAGE,
    page,
  };
}

export function deleteCalcul(calculId) {
  return {
    type: DELETE_CALCUL,
    calculId,
  };
}
export function deleteCalculSuccess(data) {
  return {
    type: DELETE_CALCUL_SUCCESS,
    payload: data,
  };
}
export function deleteCalculFailed() {
  return {
    type: DELETE_CALCUL_FAILED,
  };
}

export function duplicateCalcul(calculId) {
  return {
    type: DUPLICATE_CALCUL,
    calculId,
  };
}

export function clearCalcul() {
  return {
    type: CLEAR_CALCUL,
  };
}

export function sendXmlToEDEC(values) {
  return {
    type: SEND_XML_TO_EDEC,
    values,
  };
}

export function removeReports() {
  return {
    type: REMOVE_REPORTS,
  };
}

export function getAllUserCalculs() {
  return {
    type: GET_ALL_USER_CALCULS,
  };
}

export function updateCalculsLimit(limit) {
  return {
    type: UPDATE_CALCULS_LIMIT,
    limit,
  };
}

export function setCalculArchived(calculId, folderId) {
  return {
    type: SET_CALCUL_ARCHIVED,
    calculId,
    folderId,
  };
}

export function restoreArchivedCalcul(calculId, folderId) {
  return {
    type: RESTORE_ARCHIVED_CALCUL,
    calculId,
    folderId,
  };
}

export function changeCalculsSearch(search) {
  return {
    type: CHANGE_CALCULS_SEARCH,
    search,
  };
}

export function updateCalculAttributes(calculId, attributes) {
  return {
    type: UPDATE_CALCUL_ATTRIBUTES,
    calculId,
    attributes,
  };
}

export function manageCalculsBulk(action, calculIds, folderId) {
  return {
    type: MANAGE_CALCULS_BULK,
    action,
    calculIds,
    folderId,
  };
}

export function updateCalculsFilters(filters) {
  return {
    type: UPDATE_CALCULS_FILTERS,
    filters,
  };
}

export function openCalculsFiltersSection() {
  return {
    type: OPEN_CALCULS_FILTERS_SECTION,
  };
}

export function closeCalculsFiltersSection() {
  return {
    type: CLOSE_CALCULS_FILTERS_SECTION,
  };
}
